import { Box, Tab, Tabs } from "@mui/material";
import { useEffect } from "react";
import { NumberParam, StringParam, useQueryParam } from "use-query-params";
import CompanyContactsTab from "./CompanyContactsTab";
import IndividualContactsTab from "./IndividualContactsTab";
import { ContactsEntityType } from "./types";

const ViewContacts = () => {
  const [selectedEntityId, setSelectedEntityId] = useQueryParam("entityId", StringParam);
  const [selectedEntityType, setSelectedEntityType] = useQueryParam("entityType", NumberParam);

  useEffect(() => {
    if (selectedEntityType === null || selectedEntityType === undefined) {
      setSelectedEntityType(ContactsEntityType.Person);
    }
  }, [selectedEntityType]);

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={selectedEntityType}
        onChange={(_, newValue) => setSelectedEntityType(newValue)}
        aria-label="contactTabs"
      >
        <Tab label="Individuals" value={ContactsEntityType.Person} />
        <Tab label="Entities" value={ContactsEntityType.Company} />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {selectedEntityType === ContactsEntityType.Person && (
          <IndividualContactsTab
            setSelectedEntityId={setSelectedEntityId}
            selectedEntityId={selectedEntityId ? Number(selectedEntityId) : undefined}
          />
        )}
        {selectedEntityType === ContactsEntityType.Company && (
          <CompanyContactsTab
            setSelectedEntityId={setSelectedEntityId}
            selectedEntityId={selectedEntityId ? Number(selectedEntityId) : undefined}
          />
        )}
      </Box>
    </Box>
  );
};

export default ViewContacts;
